import React from 'react';
import { defineMessages } from 'react-intl';
import { Link } from 'react-router-dom';
import { getInsuranceSettingsPath } from '../../../routes/constants';

const messages = defineMessages({
  InactiveInsuranceProvider: {
    description: 'Error message saying the selected insurance is not available and directing the user to set it up',
    defaultMessage: 'Please set up {insuranceProvider} in the <a>Insurance Settings page</a>',
    id: 's34Z+9',
  },
});

export default ({ code, insuranceProvider }) => {
  return {
    ...messages[code],
    values: {
      insuranceProvider,
      a: (chunks) => <Link to={getInsuranceSettingsPath()}>{chunks}</Link>,
    },
  };
};
